export const REMOTE_CONFIG_BUILD_NUMBER = 'build_number';
export const REMOTE_CONFIG_UPDATE_TYPE = 'update_type';
export const REMOTE_CONFIG_LAST_FORCED_BUILD_NUMBER =
  'last_forced_build_number';
export const REMOTE_CONFIG_UPDATE_NOTES = 'update_notes';

export const REMOTE_CONFIG_OPTIONAL = 'optional';
export const REMOTE_CONFIG_FORCED = 'forced';
export const REMOTE_CONFIG_RELEASE_NOTES = 'release_notes';

export const REMOTE_CONFIG_MAINTENANCE = 'maintenance';
export const REMOTE_CONFIG_FEATURE_FLAG = 'feature_flag';

export const REMOTE_CONFIG_CODE_CONFIGS = 'code_configs';
export const REMOTE_CONFIG_CHAT_CODE_CONFIGS = 'chat_code_configs';
export const REMOTE_CONFIG_CHAT_BETA_USER_EMAILS = 'chat_beta_user_emails';
export const REMOTE_CONFIG_BANNER_TEXT = 'bonuses_text';
export const REMOTE_CONFIG_EDGE30_TEXT = 'edge30';

export const REMOTE_CONFIG_BONUS_DISPLAY_DATES = 'bonuses_display_dates';
export const REMOTE_CONFIG_CSB_PLUS_BANNER = 'csb_plus_banner';
export const REMOTE_CONFIG_MEAL_PLAN = 'plan_bundles';
export const REMOTE_CONFIG_EDGE365_CHALLENGE_TASKS = 'edge365_tasks';

export const REMOTE_CONFIG_HEALTH_CARE_PROVIDER_FIELDS =
  'health_care_provider_fields';

export const REMOTE_CONFIG_US_STATES = 'us_states';

export const REMOTE_CONFIG_COUNTRIES = 'countries_list';

export const REMOTE_CONFIG_LEADS_POOL_OPT_IN_REQUIREMENTS =
  'leads_pool_opt_in_requirements';
